import React from 'react';
import Autosuggest from 'react-autosuggest';
import {
    gAPI_GetPlace_Predict,
} from '../../../../../constants/APIs';

class ServerAutoSuggest extends React.Component {
    constructor(props) {
        super(props);

        //Define state for value and suggestion collection
        this.state = {
            value: '',
            suggestions: [],
            id: '',
            name: '',
            location: '',
            country: ''
        };
    }

    // Filter logic
    getSuggestions = async (value) => {
        const inputValue = value.trim().toLowerCase();
        let response = await fetch(`${gAPI_GetPlace_Predict}?q=${inputValue}&location=&id=`);
        let data = await response.json()
        return data;
    };

    // Trigger suggestions
    getSuggestionValue = suggestion => (suggestion.id + " " + suggestion.name + " " + suggestion.location + " " + suggestion.country);

    // Render Each Option
    renderSuggestion = suggestion => (
        <span className="sugg-option">
            {/* <span className="icon-wrap"><img src={suggestion.Poster} /></span> */}
            <span className="name">
                {suggestion.id} {suggestion.name} {suggestion.location} {suggestion.country}
            </span>
        </span>
    );

    // OnChange event handler
    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    // Suggestion rerender when user types
    onSuggestionsFetchRequested = ({ value }) => {
        this.getSuggestions(value)
            .then(data => {
                if (data.Error) {
                    this.setState({
                        suggestions: []
                    });
                } else {
                    this.setState({
                        suggestions: data.results
                    });
                } console.log(data.results);
            })
    };

    // Triggered on clear
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };
    onSuggestionSelected = (event, { suggestion, suggestionValue, sectionIndex, method }) => {
        event.stopPropagation();
        this.setState({
            id: suggestion.id,
            name: suggestion.name,
            location: suggestion.location,
            country: suggestion.country
        });
        this.props.getInputData(suggestion);
    };

    render() {
        const { value, id, name, location, country, suggestions } = this.state;

        // Option props
        const inputProps = {
            placeholder: 'Type place name',
            value,
            id,
            name,
            location,
            country,
            onChange: this.onChange
        };
        console.log(this.props);
        // Adding AutoSuggest component
        return (
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                onSuggestionSelected={this.onSuggestionSelected}
                inputProps={inputProps}
                theme={{
                    container: "autosuggest",
                    input: "form-control",
                    inputOpen: "react-autosuggest__input--open",
                    suggestionsContainer: "react-autosuggest__suggestions-container",
                    suggestionsContainerOpen:
                        "react-autosuggest__suggestions-container--open",
                    suggestionsList: `react-autosuggest__suggestions-list ${this.state.suggestions.length ? "show" : ""
                        }`,
                    suggestionFocused: "active",
                    suggestion: "react-autosuggest__suggestion"
                }}
            />
        );
    }
}

export default ServerAutoSuggest;